import React, { useState } from "react";
import { Modal, Form, Container, Col, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import authFetch from "../axios";
import { STEP, SUCCESS_STATUS_DIGIT } from "../utils";

const STEP_STATUS_LABEL = {
  [STEP.NOT]: "Pending – Face Capture",
  [STEP.FACE]: "Pending – Contact Information",
  [STEP.CONTACT]: "Pending – Assessment Test",
  [STEP.BIODATA]: "Pending – Residence Information",
  [STEP.RESIDENCE]: "Pending – Document Upload",
  [STEP.DOCUMENT]: "Completed",
};

const getStatusLabel = (step, testPassed) => {
  if (step === STEP.TEST) {
    return testPassed === false
      ? "Test Failed – Not Eligible to Continue"
      : "Pending – Bio Data";
  }
  return STEP_STATUS_LABEL[step] || "Unknown";
};

const CheckApplicationStatusModal = ({ show, onHide }) => {
  const [appNum, setAppNum] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [statusLabel, setStatusLabel] = useState(null);
  const [loading, setLoading] = useState(false);

  const resetState = () => {
    setAppNum("");
    setEmail("");
    setOtp("");
    setShowOtp(false);
    setStatusLabel(null);
    setLoading(false);
    sessionStorage.removeItem("userToken");
  };

  const handleHide = () => {
    resetState();
    onHide();
  };

  const handleCheckStatus = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const jsonData = {
        email: email,
        code: appNum,
      };

      const config = {
        method: "post",
        url: `/auth/validate-code`,
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await authFetch(config);
      if (data.palliative.status === SUCCESS_STATUS_DIGIT.SUCCESS) {
        setLoading(false);
        setShowOtp(true);
        toast.success("OTP has been sent to your email", {
          position: "top-right",
        });
      } else {
        setLoading(false);
        toast.error("Invalid access code or email", {
          position: "top-left",
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Please retry", {
        position: "top-left",
      });
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const jsonData = {
        code: appNum,
        otp: otp,
      };

      const config = {
        method: "post",
        url: `/auth/verify-code-otp`,
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await authFetch(config);
      if (
        data.palliative.status === SUCCESS_STATUS_DIGIT.SUCCESS &&
        data.palliative.token
      ) {
        sessionStorage.setItem("userToken", data.palliative.token);

        try {
          const config1 = {
            method: "get",
            url: `/auth/retrive-data`,
          };

          const { data: statusData } = await authFetch(config1);
          setStatusLabel(
            getStatusLabel(
              statusData.palliative.step,
              statusData.palliative.test_passed,
            ),
          );
          setLoading(false);
        } catch (error) {
          setLoading(false);
          toast.error("please retry", {
            position: "top-left",
          });
        } finally {
          sessionStorage.removeItem("userToken");
        }
      } else {
        setLoading(false);
        toast.error("Invalid OTP or access code", {
          position: "top-left",
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Please retry", {
        position: "top-left",
      });
    }
  };

  return (
    <Modal
      size="md"
      show={show}
      onHide={handleHide}
      aria-labelledby="check-application-status-modal-title"
    >
      <Modal.Header className="modal-header" closeButton>
        <Container>
          <Row className="text-center">
            <Col sm={12} md={12}>
              <Modal.Title
                id="check-application-status-modal-title"
                className="mx-auto"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;
                {statusLabel
                  ? "APPLICATION STATUS"
                  : showOtp
                    ? "VERIFY OTP"
                    : "CHECK APPLICATION STATUS"}
              </Modal.Title>
            </Col>
          </Row>
        </Container>
      </Modal.Header>
      <Modal.Body>
        {statusLabel ? (
          <div className="text-center py-3">
            <p className="mb-1">Your application status is:</p>
            <h5 style={{ color: "#0b6916", fontWeight: "bold" }}>
              {statusLabel}
            </h5>
          </div>
        ) : showOtp ? (
          <>
            <p>
              Please enter the One-Time Password (OTP) sent to your email to
              proceed.
            </p>
            <Form onSubmit={handleVerifyOtp}>
              <Form.Group className="mb-3" controlId="checkStatusOtpForm">
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter OTP"
                  className="form_input shadow-none"
                  name="otp"
                  onChange={(e) => setOtp(e.target.value)}
                />
              </Form.Group>
              <button type="submit" className="my-btn">
                VERIFY OTP
              </button>
            </Form>
          </>
        ) : (
          <Form onSubmit={handleCheckStatus}>
            <Form.Group className="mb-3" controlId="checkStatusAppCode">
              <Form.Control
                required
                type="text"
                placeholder="Enter Your Application Code"
                className="form_input shadow-none"
                name="app_code"
                onChange={(e) => setAppNum(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="checkStatusEmail">
              <Form.Control
                required
                type="email"
                placeholder="Enter Your Email Address"
                className="form_input shadow-none"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <button type="submit" className="my-btn">
              CHECK STATUS
            </button>
          </Form>
        )}

        {loading && (
          <div className="row py-3">
            <div className="col-6  col-md-6 mx-auto">
              <Spinner animation="border" variant="success" />
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CheckApplicationStatusModal;
